import { compose } from 'recompose';

import CaseStudiesList from './CaseStudiesList';

const enhance = compose();

export default enhance(CaseStudiesList);
